import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  Validators,
  FormControl,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
// ngrx/store
import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
// Actions
import * as CompanyAnalysisActions from "../../actions/company-analysis.actions";
import * as users from "../../actions/user.actions";

import "rxjs/add/observable/of";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import "rxjs/add/operator/catch";
const isMatch = require("lodash/isMatch"); // tslint:disable-line
const isEqualWith = require("lodash/isEqualWith"); // tslint:disable-line
const isEqual = require("lodash/isEqual"); // tslint:disable-line
const sortBy = require("lodash/sortBy"); // tslint:disable-line

@Component({
  selector: "filter-control",
  templateUrl: "filter-control.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterControlComponent {
  @Input() sectors: any = [];
  @Input() regions: any = [];
  @Input() filter: any = {};
  @Input() syntheticRegions: any = {};
  @Input() dataRanges: any = {};
  @Output() updateFilter: EventEmitter<any> = new EventEmitter<any>();
  industries: any[];
  countries: any[];
  sector: string;
  industry: string;
  region: string;
  country: string;

  _filter: any = {};

  filterSubscription: Subscription;

  marketCapB: object = { lower: 0, upper: 999999, displayFactor: 1 };
  impliedEbitY3: object = { lower: 0, upper: 99, displayFactor: 100 };
  yearThreeConsensusGrowth: object = {
    lower: 0,
    upper: 99,
    displayFactor: 100,
  };
  ebitMarginExpectation: object = { lower: 0, upper: 99, displayFactor: 100 };
  iroceExpectation: object = { lower: 0, upper: 99, displayFactor: 100 };
  initialised: boolean = false;

  formFields: any = [
    { name: "marketCapB", min: 0, max: 1, displayFactor: 1, type: "minmax" },
    {
      name: "impliedEbitY3",
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
    },
    {
      name: "yearThreeConsensusGrowth",
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
    },
    {
      name: "ebitMarginExpectation",
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
    },
    {
      name: "iroceExpectation",
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
    },
  ];

  formFieldsObj: any = {
    marketCapB: {
      min: 0,
      max: 999999,
      displayFactor: 1,
      type: "minmax",
      decimals: 1,
    },
    impliedEbitY3: {
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
      decimals: 1,
    },
    yearThreeConsensusGrowth: {
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
      decimals: 1,
    },
    ebitMarginExpectation: {
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
      decimals: 1,
    },
    iroceExpectation: {
      min: 0,
      max: 1,
      displayFactor: 100,
      type: "minmax",
      decimals: 1,
    },
  };

  private filterForm: FormGroup;
  public hasFormError: boolean = false;

  public receivedFilter: any;

  constructor(public store: Store<fromRoot.State>, public fb: FormBuilder) {}

  ngOnChanges() {
    this.receivedFilter = JSON.parse(
      JSON.stringify({ ...{ screens: {} }, ...this.filter })
    );

    this.initialised = false;
    if (this.filter.screens && this.filter.screens.sector)
      this.setIndustries(this.filter.screens.sector);
    if (this.filter.screens && this.filter.screens.region)
      this.setCountries(this.filter.screens.region);
    this.setFormFields();
    this.initialiseForm();

    setTimeout(() => {
      this.filterSubscription = this.filterForm.valueChanges
        .debounceTime(1000)
        .filter((v) => {
          return v !== undefined;
        })
        .subscribe(
          (data) => this.onFormValueChanged(data),
          (err) => {
            console.log(err);
          }
        );
      this.initialised = true;
    }, 2000);
  }

  ngOnDestroy() {
    if (this.filterSubscription) this.filterSubscription.unsubscribe();
  }

  initialiseForm() {
    if (!this.filter) return;

    this.filterForm = this.fb.group({
      sector: this.filter.screens ? this.filter.screens.sector : "All Sectors",
      industry: this.filter.screens
        ? this.filter.screens.industry
        : "All Industries",
      region: this.filter.screens ? this.filter.screens.region : "All Regions",
      country: this.filter.screens
        ? this.filter.screens.country
        : "All Countries",

      marketCapB: this.fb.group({
        $gte: this.marketCapB["lower"],
        $lte: this.marketCapB["upper"],
      }),

      yearThreeConsensusGrowth: this.fb.group({
        $gte: this.yearThreeConsensusGrowth["lower"],
        $lte: this.yearThreeConsensusGrowth["upper"],
      }),

      impliedEbitY3: this.fb.group({
        $gte: this.impliedEbitY3["lower"],
        $lte: this.impliedEbitY3["upper"],
      }),

      ebitMarginExpectation: this.fb.group({
        $gte: this.ebitMarginExpectation["lower"],
        $lte: this.ebitMarginExpectation["upper"],
      }),

      iroceExpectation: this.fb.group({
        $gte: this.iroceExpectation["lower"],
        $lte: this.iroceExpectation["upper"],
      }),
    });
  }

  onFormValueChanged(data) {
    if (!data) return;

    //Update the local object
    // this.filter.screens = Object.assign(this.filter.screens, data);
    // Trigger a db update

    Object.keys(data).forEach((key, value) => {
      if (
        this.formFieldsObj[key] &&
        this.formFieldsObj[key].type &&
        this.formFieldsObj[key].type == "minmax" &&
        this.filterForm.controls[key] &&
        this.filterForm.controls[key].dirty
      ) {
        if (data[key]) {
          data[key].$gte = parseFloat(data[key].$gte);
          data[key].$lte = parseFloat(data[key].$lte);

          // $LTE
          if (isEmpty(data[key].$lte)) {
            delete data[key].$lte;
          } else {
            data[key].$lte = data[key].$lte;
          }
          // $GTE
          if (isEmpty(data[key].$gte)) {
            delete data[key].$gte;
          } else {
            data[key].$gte = data[key].$gte;
          }
          if (Object.keys(data[key]).length == 0) {
            delete data[key];
          } else {
          }
        }
      } else if (this.formFieldsObj[key] && this.formFieldsObj[key].values) {
        data[key] = this.formFieldsObj[key].values[data[key]]
          ? this.formFieldsObj[key].values[data[key]].value
          : { $exists: true };
      } else {
      }

      if (data[key] && Object.keys(data[key]).length == 0) {
        delete data[key];
      } else {
      }
    });

    this.filterForm.markAsPristine();
    this.filterForm.markAsUntouched();

    this._updateFilter(data);
  }

  setFormFields() {
    if (this.filter.screens) {
      this.formFields.forEach((f) => {
        if (this.filter.screens[f.name]) {
          this[f.name] = {
            displayFactor: f.displayFactor,
            lower: this.filter.screens[f.name].$gte * f.displayFactor,
            upper: this.filter.screens[f.name].$lte * f.displayFactor,
          };

          this[f.name].lower = parseFloat(this[f.name].lower).toFixed(
            f.decimals || 1
          );
          this[f.name].upper = parseFloat(this[f.name].upper).toFixed(
            f.decimals || 1
          );
        } else {
          this[f.name] = {
            displayFactor: f.displayFactor,
            lower: null,
            upper: null,
          };
        }
      });
    }
  }

  updateSector(sector) {
    this.filterForm.controls["industry"].setValue(undefined);
    setTimeout(() => {
      if (sector == "All Sectors") sector = undefined;
      this.setIndustries(sector);
    }, 200);
  }

  updateIndustry(industry) {
    if (industry == "All Industries") industry = undefined;
    // this.filter = { ...this.filter, ...{ screens: { industry } } };
  }

  updateRegion(region) {
    this.filterForm.controls["country"].setValue(undefined);
    setTimeout(() => {
      if (region == "All Regions") region = undefined;
      this.setCountries(region);
    }, 200);
  }
  updateCountry(country) {
    if (country == "All Countries") country = undefined;
    // this.filter = { ...this.filter, ...{ screens: { country } } };
  }

  updateField(field, v) {
    this.receivedFilter.screens[field] = {
      $gte: v.value.lower / this.formFieldsObj[field].displayFactor,
      $lte: v.value.upper / this.formFieldsObj[field].displayFactor,
    };
    // this._updateFilter(this.filter);
  }

  _updateFilter(data) {
    if (!this.initialised) return;
    //Remove All x
    // this.filter.screens['marketCap'] = undefined;

    if (!data.sector && isEmpty(data.sector)) delete data.sector;
    if (!data.industry && isEmpty(data.industry)) delete data.industry;
    if (!data.region && isEmpty(data.region)) delete data.region;
    if (!data.country && isEmpty(data.country)) delete data.country;

    if (data.sector && data.sector === "All Sectors") delete data.sector;
    if (data.industry && data.industry === "All Industries")
      delete data.industry;
    if (data.region && data.region === "All Regions") delete data.region;
    if (data.country && data.country === "All Countries") delete data.country;

    //Clean up all the screening data
    this.formFields.forEach((f) => {
      //Are there values?
      if (data[f.name]) {
        Object.keys(data[f.name]).forEach((i) => {
          //Check if null
          if (isEmpty(data[f.name][i])) {
            delete data[f.name][i];
          } else {
            data[f.name][i] =
              data[f.name][i] / this.formFieldsObj[f.name].displayFactor;
          }
        });

        if (Object.keys(data[f.name]).length == 0) {
          delete data[f.name];
        }
      }
    });

    let updatedFilter = { ...this.receivedFilter, ...{ screens: data } };

    this.updateFilter.emit(updatedFilter);
  }

  _resetFilter() {
    // this.filter.screens['marketCap'] = undefined;
    let updatedFilter = { ...this.filter };
    updatedFilter.screens = {};
    this.updateFilter.emit(updatedFilter);
  }

  setIndustries(sector) {
    if (this.sectors.length == 0) return;
    try {
      if (!sector) {
        this.industries = [];
        this.sectors.map((s) => {
          this.industries.push(...s.industries);
        });
      } else {
        this.industries = this.sectors.find(
          (s) => s.name === sector
        ).industries;
      }
      this.industries = sortBy(this.industries, (i) => i.name);
    } catch (e) {
      console.error("Errorindustries in filter control setting:", e);
    }
  }
  setCountries(region) {
    if (!region) {
      this.countries = [];
      return;
    }

    this.countries = [...this.regions, ...this.syntheticRegions].find(
      (s) => s.name === region
    )
      ? [...this.regions, ...this.syntheticRegions].find(
          (s) => s.name === region
        ).countries
      : [];
  }
}

function isEmpty(val) {
  let lreturn: boolean;

  if (val == 0) lreturn = false;
  lreturn =
    isNaN(val) || val === undefined || val == null || val.length <= 0
      ? true
      : false;
  return lreturn;
}



// WEBPACK FOOTER //
// ./src/components/filter-control/filter-control.ts